<template>
  <v-app id="app" class="fill-height">
    <v-main>
      <template v-if="isFetched">
        <router-view />
      </template>
      <main-loader v-else />
      <the-snackbar />
    </v-main>
  </v-app>
</template>

<script>
import { call, get } from 'vuex-pathify';

import TheSnackbar from '@/components/shared/TheSnackbar';
import MainLoader from '@/components/shared/MainLoader';

export default {
  name: 'App',
  components: { TheSnackbar, MainLoader },
  data: () => ({
    isFetched: false,
  }),
  computed: {
    currentLng() {
      return this.$i18n.locale;
    },
    settingsValues: get('admin/settings'),
    offersLayersIds() {
      return this.$_config.languages.reduce((total, lng) => {
        total[lng] = ['brownfields', 'greenfields', 'invested'].reduce((tot, cur) => {
          tot[cur] = this.settingsValues[`${cur.toLocaleUpperCase()}_LAYERS_SETTING`]?.value?.layers?.[lng];
          return tot;
        }, {});
        return total;
      }, {});
    },
  },
  watch: {
    currentLng(nV) {
      if (!nV) return;
      localStorage.setItem('lng', nV);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    getSettings: call('admin/getSettings'),
    async init() {
      document.title = this.$_config.appName;
      const lng =
        this.$_config.languages.find(language => language === localStorage.getItem('lng')) ||
        this.$_config.languages.find(language => window.navigator.language.startsWith(language)) ||
        this.$_config.defaultLanguage;
      this.$i18n.locale = lng;
      this.$vuetify.lang.current = lng;
      this.$dayjs.locale(lng);
      await this.getSettings();
      setTimeout(() => {
        this.checkUrl();
        this.isFetched = true;
      }, 100);
    },
    checkUrl() {
      if (Object.values(this.offersLayersIds[this.currentLng]).find(l => l == this.$route.params.lid)) return;
      else {
        for (const lngData of Object.values(this.offersLayersIds)) {
          for (const [type, layer] of Object.entries(lngData)) {
            if (layer == this.$route.params.lid) {
              this.$router.push({
                ...this.$route,
                params: { ...this.$route.params, lid: this.offersLayersIds[this.currentLng][type] },
              });
              return;
            }
          }
        }
      }
    },
  },
};
</script>
